// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectOrganisationQueryResult, selectOrganisationsPageLoading, selectOrganisationsShowInitWaitingMessage} from '../_selectors/organisation.selectors';

export class OrganisationsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectOrganisationsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectOrganisationsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectOrganisationQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
